module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[58]57.55be1e4.woff2";